
// This file is the main entry point for the theme's JS and SCSS for WebPack to compile using wp-scripts in package.json.
import './scss/style.scss';   
import './js/scripts.js'; 
import './js/tracking.js'; 
import './js/lucide-fonts.js'; 
